/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import React, { Component } from 'react';
import AlertMessage from './Alert';

class Credits extends Component {
    render() {
        return (
            <div id="main"
                className="grid md:grid-flow-col-dense sm:grid-flow-row-dense grid-cols-6 gap-4 my-4">

                <section className="col-start-2 col-span-4">
                    <AlertMessage />
                    <div className="py-8 lg:py-16 px-4 mx-auto text-gray-900 dark:text-white">
                        <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-center">Credits</h2>
                        <div className="flex flex-col mb-4 pb-4">
                                <h3 className="text-xl font-bold mb-2">
                                We would like to acknowledge the following organizations for their invaluable contributions to the development of InDeep<sup>Net</sup>:
                                </h3>
                            </div>
                            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                        <tr>
                                            <th scope="col" className="px-6 py-3">
                                            </th>
                                            <th scope="col" className="px-6 py-3">
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            <a className="link-primary" href="https://www.pasteur.fr">Intitut Pasteur</a>
                                            </th>
                                            <td className="px-6 py-4">
                                            For hosting the website and providing GPU computing resources for the server.
                                            </td>
                                        </tr>
                                        <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            <a className="link-primary" href="https://www.lafondation3ds.org/fr/">Dassault Foundation</a>
                                            </th>
                                            <td className="px-6 py-4">
                                            For sponsoring human resources.
                                            </td>
                                        </tr>
                                        <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            <a className="link-primary" href="https://www.eyesopen.com/">OpenEye</a>
                                            </th>
                                            <td className="px-6 py-4">
                                            For data processing prior to the online launch.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    </div>
                </section >
            </div>
        );
    }
}

export default Credits;